import baseMessage from './baseMessage'
import { merge, cloneDeep } from 'lodash'

const cloneObj = cloneDeep(baseMessage)

const message = merge(
  cloneObj,
  {
    searchComponent: {
      employees_list_search_desc:
        'Para realizar una búsqueda puede ingresar el Nombre, Apellido, Cédula de identidad o Email del empleado en el campo de búsqueda o seleccionar una combinación de filtros.',
      search_text_1_1: 'Cédula de identidad, Nombre, Apellido o Email',
      head_text_table_search_3: 'Cédula de identidad',
    },
    errorReference: {
      '00126': 'La cédula de identidad (CI) no puede ser nulo',
      '00128': 'La cédula de identidad (CI) ya existe',
    },
    LicensesManager: {
      search: {
        userHint: 'Se puede buscar por nombre, apellido o cédula de identidad (CI)',
      }
    },
    label: {
      dni: 'Cédula de identidad (CI)',
      cis: 'Cédulas de identidad (CI)',
      userHint: 'Se puede buscar por Nombres, Apellidos, Cédula de identidad'
    }
  }
)

export const ES_BO = {
  message
}
